import ExaminationEventDetails from './ExaminationEventDetails';

export default ExaminationEventDetails;
